import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiToogleComponent } from './ui-toogle/ui-toogle.component';
import { UiRadioInputComponent } from './ui-radio-input/ui-radio-input.component';
import { UiChecboxInputComponent } from './ui-checbox-input/ui-checbox-input.component';
import { UiSelectComponent } from './ui-select/ui-select.component';
import { UiButtonComponent } from './ui-button/ui-button.component';
import { AudioComponent } from './audio/audio.component';
import { UIInputPhoneModule } from './ui-input-phone/ui-input-phone.module';
import { NzShareModule } from '../nz/nz-share.module';
import { UIInputPasswordModule } from "./ui-input-password/ui-input-password.module";
import { UIInputModule } from "./ui-input/ui-input.module";
import { UIIconModule } from "./ui-icon/ui-icon.module";
import { UIInputEmailModule } from './ui-input-email/ui-input-email.module';

@NgModule({
  declarations: [
    UiToogleComponent,
    UiRadioInputComponent,
    UiChecboxInputComponent,
    UiSelectComponent,
    UiButtonComponent,
    AudioComponent,
  ],
  exports: [
    UiToogleComponent,
    UiRadioInputComponent,
    UiChecboxInputComponent,
    UiSelectComponent,
    UiButtonComponent,
    AudioComponent,
    UIInputPhoneModule,
    UIInputPasswordModule,
    UIInputModule,
    UIIconModule,
    UIInputEmailModule
  ],
  imports: [
    CommonModule,
    UIInputPhoneModule,
    NzShareModule,
    UIInputPasswordModule,
    UIInputModule,
    UIIconModule,
    UIInputEmailModule
  ]
})
export class UIModule {}
